const mbToBytes = (size: number): number => size * 1024 ** 2;

export default mbToBytes;
